<template>
    <v-container
        fluid
        fill-height
      >
        <v-layout
          align-center
          justify-center
        >
          <v-flex
            xs12
            sm8
            md4
          >
            <v-card class="elevation-12">
              <v-toolbar
                color="red"
                dark
                flat
              >
                <v-toolbar-title>Please Reset Password (At least 6 characters)</v-toolbar-title>
                <v-spacer></v-spacer>               
              </v-toolbar>
              <v-card-text>
                <v-form>
                  <v-text-field
                    v-model="passwordInfo.password1"
                    id="password1"
                    label="Password"
                    name="password1"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>

                  <v-text-field
                    v-model="passwordInfo.password2"
                    id="password2"
                    label="Password Again"
                    name="password2"
                    prepend-icon="mdi-lock"
                    type="password"
                  ></v-text-field>
                  <p class="error" v-if="this.passwordInfo.invalidFeedback">{{ this.passwordInfo.invalidFeedback }}</p>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-btn color="red"
                @click="reset">Reset</v-btn>

                <v-spacer></v-spacer>

                <v-btn color="danger"
                @click="backToHome">Back</v-btn>
                
                
              </v-card-actions>
            </v-card>
          </v-flex>
        </v-layout>
      </v-container>
</template>

<script>
const RESET_API_URL = 'users/resetPassword';

export default {
  name: 'login',
  data(){
    return {
        passwordInfo:{
            password1 : '',
            password2 : '',
            invalidFeedback : ''
        },
    }
  },
  methods: {
    reset() {

        if(!this.passwordInfo.password1 ){
          this.passwordInfo.invalidFeedback = 'Please enter password!';
          return;
        }
         
        if(!this.passwordInfo.password2 ){
          this.passwordInfo.invalidFeedback = 'Please enter password again!';
          return;
        }

        this.validatePasswords(this.passwordInfo.password1,this.passwordInfo.password2);
        if(this.passwordInfo.invalidFeedback.length>0) return;

        const resetParams = new FormData();
        resetParams.append('password', this.passwordInfo.password1);

        const headers = {
          "Content-Type": "application/x-www-form-urlencoded",            
          "Cache-Control": "no-cache",
          "reset_token": localStorage.getItem('reset_token')
        }

        this.$axios.post(this.$apiurl + RESET_API_URL, resetParams,{ headers:  headers})        
        .then(response => {
          localStorage.setItem('access_token','');
          localStorage.setItem('refresh_token','');
            this.$router.push({ name: 'login' })
        }) 
        .catch(error => {
          console.log(error);
            if (error.response.status === 401) {          
              this.passwordInfo.invalidFeedback = 'Password couldnot be reset'
            }
        }); 
    },
    backToHome(){
      this.$router.push({ name: 'home' })
    },
    validatePasswords(password1, password2){
      this.passwordInfo.invalidFeedback ='';
      if(!password1){
        this.passwordInfo.invalidFeedback = 'Please enter a valid password';
      }

      if(password1.length < 6 || password2.length < 6){
        this.passwordInfo.invalidFeedback =  'Password should be at least 6 characters';
      }

      if(!password2)
        this.passwordInfo.invalidFeedback =  'Please enter password again';

      if(password1 !== password2 ){
        this.passwordInfo.invalidFeedback =  'Passwords should be identical';
      }
    }
  }
}
</script>